import script from "./PCContent.vue?vue&type=script&setup=true&lang=js"
export * from "./PCContent.vue?vue&type=script&setup=true&lang=js"

import "./PCContent.vue?vue&type=style&index=0&id=66348af0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66348af0"]])

export default __exports__